import { useNavigate } from 'react-router-dom';
import { ReactNode, useEffect, useState } from 'react';
import * as Sentry from '@sentry/react';

import { useAuthContext } from '@/hooks/useAuth';
import { useGetMe } from '@/hooks/user/useGetMe';
import { UserStore, useUserStore } from '@/stores/user';

import i18n from '@/i18n';
import { useOrganizationStore } from '@/stores/organization';
import { useCommonStore } from '@/stores/common';

const RequireAuth = ({ children }: { children: ReactNode }) => {
  const { isLoggedIn } = useAuthContext();
  const navigate = useNavigate();
  const [hasError, setHasError] = useState(true);
  const setUser = useUserStore((state: UserStore) => state.setUser);
  const setOrganization = useOrganizationStore((state) => state.setOrganization);
  const isLoggingOut = useCommonStore((state) => state.isLoggingOut);

  // const { sendRequest, loading } = useApi<UserType>({
  //   url: endpoints.me,
  //   method: 'get',
  // });
  const { data: userProfile, isError, isPending } = useGetMe();

  useEffect(() => {
    if (!isLoggedIn) {
      navigate('/login');
    }
  }, [isLoggedIn, navigate]);

  useEffect(() => {
    if (isError) {
      setHasError(true);
    } else if (!isPending && userProfile) {
      i18n.changeLanguage(userProfile.user.language);
      setOrganization(userProfile.organization);
      setUser(userProfile.user);
      Sentry.setUser({
        id: userProfile.user.id.toString(),
        email: userProfile.user.email,
      });
      setHasError(false);
    }
  }, [isError, isPending, userProfile, setUser, setOrganization]);

  if (isPending) {
    // TODO: loader
    return null;
  }

  if (hasError) {
    return null;
  }

  if (isLoggingOut) {
    return null;
  }

  return children;
};

RequireAuth.displayName = 'RequireAuth';

export default RequireAuth;
